//import { Promise } from "core-js";
import app from '@/app.js'

const state = {
    data: [],
    header: {},
    footer: {},
    columns: [],
    reports: [],
}

const getters = {
    isData: state => {
        return state.data.length > 0;
    },
    data: state => {
        return state.data == null ? [] : state.data;
    },
    header: state => {
        //console.log("getter", state.header);
        return state.header == null ? {} : state.header;
    },
    footer: state => {
        return state.footer == null ? {} : state.footer;
    },
    columns: state => {
        return state.columns == null ? [] : state.columns;
    },
    reports: state=>{
        return state.reports;
    },
    isReports: state => {
        return state.reports.length > 0;
    }
}
const actions = {
    LOAD: (context) => {
        if (context.getters.isReports) return;
        app
            .getReports()
            .then(response => {
                context.commit("set_reports", response);
            })
            .catch(error => {
                console.error(error);
            });

    },
    SET_DATA: (context, payload) => {
        return new Promise((resolve, reject) => {
            try {
                context.state.data = payload.data;
                context.state.header = payload.header;
                context.state.footer = payload.footer;
                context.state.columns = payload.columns;
                //console.log("set_response_data", payload);
                //console.log("set data header", context.state.header);
                //console.log("getter set header", context.getters.header);
                //        context.commit('set_response_data', payload);
                resolve();
            } catch (e) {
                console.error(e);
                reject(e)
            }
        })
    }
}

const mutations = {
    set_reports: (state, payload) => {
        try {
            state.reports = [...payload].sort((a, b)=>{
                if(a.nameId < b.nameId) return -1;
                if(a.nameId > b.nameId) return 1;
                return 0;
            });
        } catch (e) {
            console.error(e);
        }
    },
    set_response_data: (state, payload) => {
        //return new Promise((resolve, reject) => {
        try {
            state.data = [...payload.data];
            state.header = { ...payload.header };
            state.footer = { ...payload.footer };
            state.columns = [...payload.columns];
            //console.log("set_response_data", payload);
            //console.log("set data header", state.header);
            //resolve();
        } catch (e) {
            console.error(e);
            //reject(e)
        }
        //});
    },
    clean: (state) => {
        state.reports = [];
    },
    clear_data: (state) => {
        state.data = [];
        state.header= {};
        state.footer= {};
        state.columns= [];
        state.reports= [];
        }
}

const Report = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}

export default Report;